import { useQuery } from '@tanstack/react-query';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '@/backend/lib/firebase';
import type { User } from 'firebase/auth';

export function useAdminRole(user: User | null, authLoading: boolean) {
  return useQuery({
    queryKey: ['admin-role', user?.uid],
    queryFn: async () => {
      const userDoc = await getDoc(doc(db, 'users', user!.uid));
      return userDoc.exists() && userDoc.data()?.role === 'admin';
    },
    enabled: !!user && !authLoading,
    staleTime: 5 * 60 * 1000,
  });
}
